<template>
  <Forms
    ref="frmPermission"
    :title="'Buscar Usuário'"
    :showHelp="true"
    :showClearButtonIcon="true"
    :showSearchButtonIcon="true"
    :ShowFooterImbo="true"
    v-on:Clear="Clear"
    v-on:Search="Search"
  >
    <div>
      <label class="label-search">Nome</label>
      <autocomplete-z v-if="searchByCliente == true" ref="ClienteTypeahead"
             placeholder="Buscar por nome"
             iconClass="fas fa-file-alt"
             :serializer="(Usuario) => Usuario.nome"
             :debounceLength="3"
             :formField="dataSearch.usuario"
             v-on:search="onSearchCliente"
             v-on:changeCode="onSearchCliente"
             :ShowCode="false"
            />
      <autocomplete-z v-if="searchByCliente == false" ref="ClienteTypeahead"
             placeholder="Buscar por nome"
             iconClass="fas fa-file-alt"
             :serializer="(Usuario) => Usuario.nome"
             :debounceLength="3"
             :formField="dataSearch.usuario"
             v-on:search="onSearchUsuario"
             v-on:changeCode="onSearchUsuario"
             :ShowCode="false"
            />
      <label class="label-search mt-3">CPF</label>
      <b-form-group>
        <b-form-input
        class="form-control"
        v-model="cpfField"
        v-validate="{ required: true, length: 14, numeric: false }"
        type="text"
        placeholder="___.___.___-__"
        required
        v-mask="['###.###.###-##']"
        ></b-form-input>
      </b-form-group>
      <label class="label-search mt-3">RG</label>
      <input v-model="dataSearch.rg" class="form-control" placeholder="Busca por RG" />

      <label v-if="showCreci" class="label-search mt-3">CRECI</label>
      <input v-if="showCreci" v-model="dataSearch.creci" class="form-control" placeholder="Busca por CRECI" />
      <label  v-if="searchByCliente == true" class="label-search mt-3">Status</label>
      <select
        v-if="searchByCliente == true"
        name="statusVistoria"
        class="form-control"
        v-model="dataSearch.statusSelecionado"
        id="exampleFormControlSelect2"
      >
        <option v-for="status in userStatus" :key="status.value" :value="status.value">{{status.text}}</option>
      </select>
      <label class="labeldate">Data de Cadastro</label>
        <div style="width: 100%;">
          <label class="labeldate">Desde</label>
          <datepicker
            v-model="dataSearch.dataCadastroInicio"
            class="datepicker"
            name="txtDateStart"
            :format="'dd/MM/yyyy'"
            :language="ptBR"
            :placeholder="$lang.Common.DatePlaceholder"
            :clear-button="true"
            :clear-button-icon="'fas fa-times'"
            :calendar-button="true"
            :calendar-button-icon="'fa fa-calendar'"
            :bootstrap-styling="true"
            :full-month-name="true"
            :use-utc="true"
          />
        </div>
        <div style="width: 100%">
          <label class="labeldate margem">Até</label>
          <datepicker
            v-model="dataSearch.dataCadastroFim"
            name="txtDateStart"
            class="datepicker"
            :format="'dd/MM/yyyy'"
            :language="ptBR"
            :placeholder="$lang.Common.DatePlaceholder"
            :clear-button="true"
            :clear-button-icon="'fas fa-times'"
            :calendar-button="true"
            :calendar-button-icon="'fa fa-calendar'"
            :bootstrap-styling="true"
            :full-month-name="true"
            :use-utc="true"
          />
        </div>
    </div>
  </Forms>
</template>
<script>
import UserSearchCard from '@/views/private/realestate/users/components/UserSearchCard/UserSearchCard.js'
export default UserSearchCard
</script>
<style scoped>
.padding{
  padding-bottom: 1rem;
}
.labeldate{
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: bold;
  color: #666666;
  font-family: 'Segoe UI';
}
.labeldate-ate{
   margin-bottom: 3px;
   font-size: 14px;
   color: #666666;
   font-family: 'Segoe UI';
}
.label-search {
  font-weight: bold;
  color: #666666;
  font-size: 14px;
  margin-bottom: 5px;
  padding-bottom: 0px;
  font-family: 'Segoe UI';
}
#datapicker-search {
  display: flex;
  justify-content: space-between;
}
#a-datapicker {
  font-size: 18px;
}
.datepicker {
  width: 100%;
}

.margem{
  margin-top: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/users/components/UserSearchCard/UserSearchCard.vue